import { useIntl } from 'react-intl';
import { ButtonUI, SpinnerV2 } from 'sonata-react-components';

import { usePOIImporter } from '@/components/common/POIImporter/POIImporter.context';

import './fileLoader.scss';

export function FileLoader() {
  const { formatMessage } = useIntl();
  const { processingStatus, setShowModal, isModalShowed } = usePOIImporter();
  const showProcessing = !isModalShowed && processingStatus === 'processing';
  const showSuccess = processingStatus === 'success';

  if (!showProcessing && !showSuccess) {
    return null;
  }

  return (
    <div className="fileLoader">
      {showProcessing && (
        <>
          <SpinnerV2 id={'file-loader-spinner'} />
          <p className="fileLoader__text">
            {formatMessage({
              defaultMessage: 'Loading file',
              id: 'attributionPOI.modal.fileLoader.processing'
            })}
          </p>
          <ButtonUI
            icon="fa-regular fa-arrows-maximize"
            iconPosition="right"
            onClick={() => setShowModal(true)}
            shape="link"
            size="ultraSmall"
            type="secondary"
          />
        </>
      )}
      {showSuccess && (
        <>
          <i className="fa-regular fa-circle-info fileLoader__icon"></i>
          <div className="fileLoader__container">
            <p className="fileLoader__text">
              {formatMessage({
                defaultMessage: 'File ready for review',
                id: 'attributionPOI.modal.fileLoader.ready'
              })}
            </p>
            <p className="fileLoader__description">
              {formatMessage({
                defaultMessage: 'An action is required.',
                id: 'attributionPOI.modal.fileLoader.actionRequired'
              })}
            </p>
          </div>
          <ButtonUI
            icon="fa-regular fa-arrows-maximize"
            iconPosition="right"
            onClick={() => setShowModal(true)}
            shape="link"
            size="ultraSmall"
            type="secondary"
          />
        </>
      )}
    </div>
  );
}
